import SEO from './SEO';
import { buildUrl } from '../../config/seo';

const TopicSEO = ({ title, description, questions, topicPath }) => {
  // Clean title for SEO
  const cleanTitle = title.replace(' Questions', '');
  const pageTitle = `${cleanTitle} Interview Questions - Comprehensive Guide`;
  const pageDescription = `Master ${cleanTitle} interviews with ${questions.length} detailed questions and answers. ${description}`;

  // Use topicPath if provided, otherwise fallback to slug generation
  const urlPath = topicPath || `/${cleanTitle.toLowerCase().replace(/\s+/g, '-')}`;
  const pageUrl = buildUrl(urlPath);

  return (
    <SEO
      title={pageTitle}
      description={pageDescription}
      keywords={`${cleanTitle} interview questions, ${cleanTitle} interview, ${cleanTitle} developer interview, ${cleanTitle} coding questions, interview preparation, programming interview, ${cleanTitle} tutorial, ${cleanTitle} concepts`}
      url={pageUrl}
      structuredData={{
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "name": pageTitle,
        "description": pageDescription,
        "url": pageUrl,
        "mainEntity": questions.slice(0, 10).map((q, index) => ({
          "@type": "Question",
          "name": q.question,
          "position": index + 1,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": Array.isArray(q.parts) ? q.parts.map(p => p.answer).join(' ') : q.answer || ''
          }
        })),
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": buildUrl('/')
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": cleanTitle,
              "item": pageUrl
            }
          ]
        }
      }}
    />
  );
};

export default TopicSEO;